module.exports = __webpack_public_path__ + "media/klaseaDia3K62.cb079534.mp4";